import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-wrapper">
      <div className="footer-container">
        {/* Left Side Brand Text */}
        <div className="footer-about">
          <p className="footer-tagline">
            We empower individuals and communities through counseling, education guidance, and sustainable development programs, creating meaningful impact one step at a time.
          </p>

        </div>

        {/* Middle - Links */}
        <div className="footer-links">
          <div className="footer-column">
            <h4>Company</h4>
            <a href="/">Home</a>
            <a href="/about">About Us</a>
            <a href="/services">Services</a>
            <a href="/contact">Contacts</a>
          </div>

          <div className="footer-column">
            <h4>Internal Links</h4>
            <a href="/">Blog</a>
            <a href="/">Case-Study</a>
            <a href="/">Study in Russia</a>
            <a href="/">Apply Schorlaship</a>
          </div>

          <div className="footer-column">
            <h4>Social</h4>
            <a href="/">Facebook</a>
            <a href="/">Instagram</a>
            <a href="/">LinkedIn</a>
            <a href="/">Twitter</a>
          </div>
        </div>
      </div>

      {/* Bottom row: Telephone — Email — Copyright */}
      <div className="footer-contact-row">
        <span>Tel: +254 20 5226693</span>
        <span>|</span>
        <a href="mailto:info@simbaeducationconsultants.org">
          info@simbaeducationconsultants.org
        </a>
        <span>|</span>
        <span>© 2025 all rights reserved.</span>
      </div>

      {/* Brand */}
      <div className="footer-bottom">
        <h2>SIMBA CONSULTANTS</h2>
      </div>
    </footer>
  );
};

export default Footer;
